import { Modal } from "@components";
import { useNavigate } from "react-router-dom";
import { useDocumentSignatureContext } from "@contexts";
import { defaultPinState, RequestType } from "@interfaces";
import { styled, Link as MuiLink } from "@mui/material";
import { getFromLocalStorage, onContactUsClick } from "@utils/index";
import { redirectToDocumentCreationScreen } from "@utils/redirect";
import { failedCreationWsp } from "@constants/index";

const Link = styled(MuiLink)(({ theme }) => ({
  textAlign: "center",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "23px",
  letterSpacing: "0.5px",
  color: theme.palette.text.link,
  cursor: "pointer",
}));
interface Props {
  requestId: string;
}

export function UnknownDocumentCreationErrorModal({ requestId }: Props) {
  const navigate = useNavigate();

  const requestType = getFromLocalStorage<RequestType>({
    key: "requestType",
  }) as RequestType;

  const { showCreationErrorModal, setPinState, setShowCreationErrorModal } =
    useDocumentSignatureContext();

  return (
    <Modal
      title="Error al generar la receta"
      content={
        <>
          Por favor, intenta nuevamente. Si el error persiste,{" "}
          <Link onClick={() => onContactUsClick(failedCreationWsp)}>
            contáctanos
          </Link>{" "}
          para ayudarte.
        </>
      }
      isOpen={showCreationErrorModal}
      buttonProps={{
        buttonText: "Reintentar",
        onClick: () => {
          setShowCreationErrorModal(false);
          setPinState(defaultPinState);
          navigate(redirectToDocumentCreationScreen(requestType, requestId));
        },
      }}
      secondaryButtonProps={{
        buttonText: "Volver a inicio",
        onClick: () => {
          setShowCreationErrorModal(false);
          setPinState(defaultPinState);
          navigate("/app/solicitudes");
        },
      }}
    />
  );
}
